import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import textToHtmlAttribute from 'shared/lib/textToHtmlAttribute';
import styles from './WysiwygContent.module.scss';

const WysiwygContent = ({ className, children }) => (
  <>
    <div className={cn(styles.content, className)} {...textToHtmlAttribute(children)} />
    <div className="clearer" />
  </>
);

WysiwygContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string
};
WysiwygContent.defaultProps = {
  className: null,
  children: ''
};

export default WysiwygContent;
